module.exports = __webpack_public_path__ + "img/shot_tx19120201.63bbac89.jpg";